// TokenUtils.js
import { TokenManager } from '@forgerock/javascript-sdk';
import {RENEW_BUFFER_SEC} from '../constants/SessionTimer';

/**
* Returns absolute expiry epoch (seconds), or null if unavailable.
*/
export function getExpirySeconds(tokens) {
  if (!tokens || typeof tokens.tokenExpiry !== 'number') {
    console.warn('[Auth] tokenExpiry missing from token object');
    return null;
  }
 
  // Normalize ms to seconds if needed
  return tokens.tokenExpiry > 1e12
    ? Math.floor(tokens.tokenExpiry / 1000)  
    : tokens.tokenExpiry;
}
 
/**
* Renews tokens only when within `thresholdSec` of expiry.
* Pass force=true to unconditionally renew (use sparingly).
*/

export async function getFreshTokens(opts = {}) {
  try {
    const tokens = await TokenManager.getTokens({
      forceRenew: !!opts.force,
      login: 'embedded'
    });

    return tokens || null;

  } catch (err) {
    console.error('[TokenUtils] getFreshTokens failed:', err);
    return null;
  }

}
 